import { Link, useNavigate, useSearchParams } from 'react-router-dom'

import Pagination from '@/compoments/common/Pagination'
import SearchForm from '@/compoments/common/SearchForm'

import Filters from '@/pages/Executives/ExecutivesTechnicianPerformancePage/components/Filters'

import PageLoader from '@/compoments/PageLoader'

import { useGetDispatcherTechniciansQuery } from '@/services/dispatcher/dispather'
import Table from './parts/Table'

const TechnicianManagementPage = () => {
    const [searchParams] = useSearchParams()
    const queryString = searchParams.toString()

    const { data, isLoading } = useGetDispatcherTechniciansQuery(queryString)
    const pageData = data?.data
    if (isLoading) return <PageLoader />
    return (
        <main className="content flex flex-col">
            <div className="px-container flex flex-col flex-auto">
                <div className="table-group">
                    <div className="table-header flex items-center justify-between flex-wrap">
                        <Filters />
                        <SearchForm />
                    </div>
                    <div className="table-body table-responsive p-0">
                        <Table data={pageData} />
                    </div>
                </div>
                <Pagination pagination={data?.pagination} />
            </div>
        </main>
    )
}

export default TechnicianManagementPage
